import React from 'react';
import classnames from 'classnames';

import MenuChoiceAttributes from '../MenuChoiceAttributes';
import MenuChoiceStepTitle from '../MenuChoiceStepTitle';

import { ViewerAttributeInterface, ViewerItemInterface, ViewerOptionInterface, ViewerOptionInterfaceInput, ViewerStepInterface } from '../../core';

import styles from './MenuChoiceSteps.module.scss';
import useSelectionHook from '../../hooks/use-selection';
import { useViewerState } from '../../context/ViewerContext';

export interface MenuChoiceStepsProps {
  steps: ViewerStepInterface[];
  bulkDataAttributes: ViewerAttributeInterface[] | undefined;
  setBulkDataOptionValue: (option: ViewerOptionInterfaceInput, value: string) => void;
  showOptionPreview: (option: ViewerOptionInterface) => void;
  optionSelect: (option: ViewerItemInterface) => void;
}

const MenuChoiceSteps: React.FC<MenuChoiceStepsProps> = (props) => {
  const { onSelectStep } = useSelectionHook();
  const { viewerState } = useViewerState();
  return (
    <div className={styles.ff_menu_choice_steps} data-testid='ff-menu-choice-steps'>
      {props.steps.map((step) => (
        <div
          key={step.id}
          className={classnames(styles.ff_menu_choice_step, {
            [styles.ff_menu_choice_step__open]: step.id === viewerState.stepId,
          })}
        >
          <MenuChoiceStepTitle step={step} isSelect={step.id === viewerState.stepId} select={onSelectStep} />
          <MenuChoiceAttributes
            hasParent={true}
            isActive={step.id === viewerState.stepId}
            attributes={step.attributes}
            showOptionPreview={props.showOptionPreview}
            optionSelect={props.optionSelect}
            bulkDataAttributes={props.bulkDataAttributes}
            setBulkDataOptionValue={props.setBulkDataOptionValue}
          />
        </div>
      ))}
    </div>
  );
};

export default MenuChoiceSteps;
